import { combineReducers } from 'redux';
import types from './types';

const INITIAL_DIALOG_STATE = { type: '', title: '', context: '', open: false, action: '', notFormat: false };

const isRequest = (state = false, action) => {
  switch (action.type) {
    case types.START_REQUEST:
      return true;
    case types.END_REQUEST:
      return false;
    default:
      return state;
  }
};

const dialogInfo = (state = INITIAL_DIALOG_STATE, action) => {
  switch (action.type) {
    case types.OPEN_DIALOG:
      return action.dialogInfo;
    case types.CLOSE_DIALOG:
      return { ...state, open: false, notFormat: false };
    case types.CLOSE_DIALOG_NOT_FORMAT:
      return { ...state, open: false, notFormat: true };
    default:
      return state;
  }
};

const checkAccess = (state = { time: null }, action) => {
  switch (action.type) {
    case types.CHECK_ACCESS:
      return action.accessInfo;
    default:
      return state;
  }
};

const reducer = combineReducers({
  isRequest,
  dialogInfo,
  checkAccess
});

export default reducer;
